export default __webpack_public_path__ + "static/media/calender_eduact_logo.d47ec4e6.svg";